/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LegalEntityDto } from './LegalEntityDto';
import {
    instanceOfLegalEntityDto,
    LegalEntityDtoFromJSON,
    LegalEntityDtoFromJSONTyped,
    LegalEntityDtoToJSON,
} from './LegalEntityDto';
import type { NaturalPersonDto } from './NaturalPersonDto';
import {
    instanceOfNaturalPersonDto,
    NaturalPersonDtoFromJSON,
    NaturalPersonDtoFromJSONTyped,
    NaturalPersonDtoToJSON,
} from './NaturalPersonDto';

/**
 * @type PersonDto
 * 
 * @export
 */
export type PersonDto = { type: 'morale' } & LegalEntityDto | { type: 'physique' } & NaturalPersonDto;

export function PersonDtoFromJSON(json: any): PersonDto {
    return PersonDtoFromJSONTyped(json, false);
}

export function PersonDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonDto {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'morale':
            return Object.assign({}, LegalEntityDtoFromJSONTyped(json, true), { type: 'morale' } as const);
        case 'physique':
            return Object.assign({}, NaturalPersonDtoFromJSONTyped(json, true), { type: 'physique' } as const);
        default:
            throw new Error(`No variant of PersonDto exists with 'type=${json['type']}'`);
    }
}

export function PersonDtoToJSON(json: any): any {
    return PersonDtoToJSONTyped(json, false);
}

export function PersonDtoToJSONTyped(value?: PersonDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'morale':
            return Object.assign({}, LegalEntityDtoToJSON(value), { type: 'morale' } as const);
        case 'physique':
            return Object.assign({}, NaturalPersonDtoToJSON(value), { type: 'physique' } as const);
        default:
            throw new Error(`No variant of PersonDto exists with 'type=${value['type']}'`);
    }

}

